import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";
import { ClientsResponseType } from "./NetTypes";

async function getClientsRequest(page: number) {
	return await apiClient
		.get(API.QUERY.ADMIN.CLIENTS, { params: { page, size: 10 } })
		.then((res) => res.data);
}

export async function getClientDetailRequest(id: string) {
	return await apiClient.get(API.QUERY.ADMIN.CLIENT_DETAIL(id)).then((res) => res.data);
}

export function useGetClientsRequest(page: number) {
	return useQuery<ClientsResponseType, AxiosError>({
		queryKey: ["clients", page],
		queryFn: () => getClientsRequest(page),
		refetchOnWindowFocus: true
	});
}

export function useGetClientDetailRequest(id: string) {
	return useQuery<ClientsResponseType, AxiosError>({
		queryKey: ["clients", id],
		queryFn: () => getClientDetailRequest(id)
	});
}
